import { StyledMain } from './style';

export const Main = (props) => {
  return <StyledMain {...props} />;
}

export default Main;
